/**
 * Função de easing bounce para desaceleração.
 * Retorna um valor entre 0 e 1 para um input t ∈ [0,1].
 */
function easeOutBounce(t) {
  const n1 = 7.5625;
  const d1 = 2.75;
  if (t < 1 / d1) {
    return n1 * t * t;
  } else if (t < 2 / d1) {
    t -= 1.5 / d1;
    return n1 * t * t + 0.75;
  } else if (t < 2.5 / d1) {
    t -= 2.25 / d1;
    return n1 * t * t + 0.9375;
  } else {
    t -= 2.625 / d1;
    return n1 * t * t + 0.984375;
  }
}

/**
 * Anima um elemento de texto de `start` até `end` em `duration` ms,
 * aplicando easing bounce.
 */
function animateCount(el, start, end, duration) {
  let startTime = null;
  const step = (timestamp) => {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easeOutBounce(progress);
    const current = Math.floor(start + (end - start) * eased);
    el.textContent = `+${current}`;
    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };
  requestAnimationFrame(step);
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[id^="counters-"]')
    .forEach((container) => {
      // Inicializa o Splide (desktop todos, mobile 1 por vez)
      const totalItems = container.querySelectorAll('.banner-with-counters__item').length;
      new Splide(container, {
        perPage: totalItems,
        arrows: false,
        pagination: false,
        breakpoints: {
          767: {
            perPage: 2,
            pagination: true
          }
        }
      }).mount();

      // Prepara animação de contadores só quando entrar na viewport
      const numbers = container.querySelectorAll('.banner-with-counters__number');
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            numbers.forEach((span) => {
              const target = parseInt(span.textContent.replace(/\D/g, ''), 10);
              animateCount(span, 0, target, 1500);
            });
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });

      observer.observe(container);
    });
});